export default __webpack_public_path__ + "static/media/aiPreview.c5ad400f.jpg";